import {
  BusinessItemEnum,
  BusinessModuleEnum,
  DirectionFlagEnum,
  OrderOperationEnum,
  OrderStatusEnum,
  PurchaseChannelEnum,
  TrainOperationStatusEnum,
  UserGroupEnum,
  UserRoleEnum,
  WorkflowStatusEnum,
  WorkflowTypeEnum
} from '@nankai/admin/constants';

export default {
  common: {
    title: 'NANKAI',
    action: '操作',
    process: '処理',
    back: '戻る',
    register: '登録',
    create: '作成',
    detail: '詳細',
    update: '更新',
    edit: '編集',
    modify: '修正',
    add: '追加',
    delete: '削除',
    copy: '複製',
    cancel: 'キャンセル',
    close: '閉じる',
    rescind: '取消',
    submit: '確定',
    reset: 'リセット',
    confirm: '確認',
    content: '内容',
    send: '送信',
    search: '検索',
    order: '予約',
    logout: 'ログアウト',
    file: 'ファイル',
    account: 'アカウント',
    header: 'ヘッダー',
    importConfirm: '取込確定',
    createdDate: '登録日',
    approveStatus: '承認状態',
    application: '申請',
    period: '期間',
    from: 'FROM',
    to: 'TO',
    date: '日付',
    seatAdjustment: '席調整',
    seatClassConfirm: '座席クラス確認',
    line: '路線',
    lineSelect: '路線選択',
    stationRange: '区間',
    train: '列車',
    trainName: '列車名',
    trainNameWithNo: '{{trainName}}{{trainServiceNo}}号',
    trainInfoDetail:
      '{{trainName}}{{trainServiceNo}}号（{{trainServiceNumber}}）',
    trainStatus: '運行状況',
    extraTrain: '臨時便',
    patternName: 'パターン名',
    direction: '方面',
    up: '上り',
    down: '下り',
    seat: '座席',
    note: '備考',
    inventory: '在庫',
    bulkSetting: '一括設定',
    status: 'ステータス',
    append: '追記',
    updateBefore: '変更前',
    updateAfter: '変更後',
    actionMessage: '{{action}}しました',
    searchNoResult: '検索条件に一致するデータがありません',
    noChanges: '変更がないため、更新は行いません',
    selected: '✔️',
    unavailable: 'ー',
    trainOperationStatus: {
      [TrainOperationStatusEnum.Normal]: '通常運行',
      [TrainOperationStatusEnum.Suspended]: '運休',
      [TrainOperationStatusEnum.PartialSuspended]: '部分運休'
    }
  },
  confirm: {
    title: 'ご確認ください',
    message: '{{name}}を{{action}}してもよろしいですか？',
    deleteMessage: '{{name}}を削除してもよろしいですか？',
    cancelMessage: '申請を取消します。よろしいですか？',
    createMessage:
      '登録データを削除します\n削除したデータを戻すことはできません。\nよろしいでしょうか?',
    approvedConfirm:
      '申請を承認します。\n承認後の修正、削除はできません。\nよろしいでしょうか?',
    rejectReason: '申請を拒否します。\n拒否理由を入力してください'
  },
  error: {
    systemError:
      'システムエラーが発生しました。しばらく経ってから再度お試しください。',
    dataNotFoundError: '対象データがありません',
    unregistered: '{{name}}が登録されていません。登録してください。',
    authRequired: 'ログインが必要です',
    authExpired: 'セッションが切れました、再度ログインしてください。'
  },
  layouts: {
    sidebar: {
      masterManager: 'マスタ管理',
      seatAdjustmentSetting: '座席配置設定',
      stationStopPatternSetting: '停車駅設定',
      trainSchedule: '運行期間',
      trainAssignment: '車両運用確定処理',
      calendar: 'カレンダー',
      serviceManager: '運用管理',
      applies: '申請/承認',
      suspension: '運休/運休解除',
      inventoryTrainSeat: '列車予約受付',
      trainOrders: '列車予約一覧',
      specialSeatAdjustmentUpdate: '枠扱い区分変更',
      seatAvailabilityInquiry: '空席状況照会',
      seatOrderHistory: '座席履歴照会',
      stationSeatingTimetable: '時刻表',
      userManager: 'ユーザー管理',
      userManagement: 'アカウント管理',
      passwordUpdate: 'パスワード変更',
      operationLog: '操作履歴'
    }
  },
  views: {
    login: {
      title: 'ようこそ',
      email: 'メールアドレス',
      password: 'パスワード',
      signIn: 'ログイン',
      forgotPassword: 'パスワードをお忘れの場合'
    },
    password: {
      currentPassword: '現在のパスワード',
      newPassword: '新しいパスワード',
      update: {
        title: 'パスワード変更',
        successMessage: 'パスワードを変更しました。'
      },
      reset: {
        title: 'パスワード再設定',
        sendEmail: 'パスワードリセットメールを送信する',
        sendEmailSuccess:
          'パスワード再設定用のURLが{{email}}に送信されます。ご確認の上パスワードをリセットしてください。',
        sendEmailSuccessShort:
          '{{email}}にパスワードリセットメールを送信しました。'
      },
      confirm: {
        title: 'パスワードを再設定',
        newPassword: '新しいパスワード',
        changeSuccess: 'パスワードを変更しました。',
        rules: {
          title: '注記：パスワードルール',
          tips1: '最低でも12文字以上の文字数で構成されている',
          tips2:
            'パスワードの中に数字や、「@」、「%」、「"」などの記号も混ぜている',
          tips3:
            'パスワード内のアルファベットに大文字と小文字の両方を入れている'
        },
        successToResetPassword: 'パスワードのリセットが成功しました。',
        backToLogin: 'ログイン画面に戻る'
      }
    },
    dashboard: {
      title: 'ダッシュボード',
      workflowStatus: '申請状況',
      updatedAt: '更新日時',
      workflowId: '申請ID',
      type: '機能',
      status: 'ステータス',
      statusMessage: {
        [WorkflowStatusEnum.Submitted]: '申請されました',
        [WorkflowStatusEnum.Cancelled]: '申請が取下げされました',
        [WorkflowStatusEnum.Approved]: '承認されました',
        [WorkflowStatusEnum.Rejected]: '拒否されました'
      },
      reservedHeadcount: '予約人数確認',
      departureStation: '始発駅',
      travallerCount: '乗車人数',
      updatedBy: '更新者'
    },
    applies: {
      title: '申請一覧',
      filters: {
        function: '申請機能',
        functionPlaceholder: '申請機能を選択',
        status: '申請状況',
        statusPlaceholder: '申請状況を選択',
        search: '検索'
      },
      type: {
        [WorkflowTypeEnum.TrainSchedule]: '座指ダイヤ',
        [WorkflowTypeEnum.Calendar]: '運行カレンダー',
        [WorkflowTypeEnum.TrainAssignment]: '車両運用確定処理'
      },
      columns: {
        appliedAt: '申請日時',
        applicant: '申請者',
        function: '申請機能',
        status: '申請状況'
      },
      status: {
        [WorkflowStatusEnum.Unsubmitted]: '申請前',
        [WorkflowStatusEnum.Submitted]: '申請済',
        [WorkflowStatusEnum.Cancelled]: '申請取消',
        [WorkflowStatusEnum.Approved]: '承認',
        [WorkflowStatusEnum.Rejected]: '拒否'
      },
      empty: '申請情報がありません。',
      detail: {
        dialogTitle: '申請内容詳細',
        sectionTitle: {
          [WorkflowTypeEnum.Calendar]: '運行カレンダー申請',
          [WorkflowTypeEnum.TrainSchedule]: '座指ダイヤ申請',
          [WorkflowTypeEnum.TrainAssignment]: '車両運用確定申請'
        },
        fields: {
          id: '申請ID',
          lineName: '路線',
          operationPeriod: '運用期間',
          manager: '管理者',
          approvedAt: '承認処理日時',
          submittedAt: '申請日時',
          updatedAt: '更新日時',
          businessRefId: '参照ID',
          rejectReason: '拒否理由'
        },
        actions: {
          runCalendar: '運行カレンダーを開く',
          seatDiagram: '座指ダイヤを開く',
          vehicleOperation: '車両運用確認'
        },
        noData: '申請詳細が取得できませんでした。'
      }
    },
    train: {
      title: '登録車両',
      lineName: '線路名',
      name: '車両名',
      number: '車両番号'
    },
    seatClass: {
      title: '座席クラス',
      carNo: '{{carNo}}号車',
      entrance: 'エントランス'
    },
    seatAdjustment: {
      list: {
        title: '席調整一覧'
      },
      common: '共通便適用',
      individual: '便別適用',
      carName: '車両',
      startDate: '適用開始日',
      individualAdjustmentFrom: '適用年',
      name: '席調整名称',
      legends: '席調整タイプ',
      type: {
        directSalesOta: '直販/OTA',
        adjustment: '調整',
        wheelChairs: '車椅子席',
        directSales: '直販',
        ota: 'OTA',
        group: '団体',
        other: 'その他枠'
      },
      invalidSeatAdjustmentType: '席に調整タイプ'
    },
    stationStopPattern: {
      title: '停車駅パターン',
      patternName: 'パターン名',
      direction: '方向',
      stationStopSelect: '停車駅選択'
    },
    trainSchedule: {
      title: '座指ダイヤ一覧',
      createTitle: '座指ダイヤ登録',
      scheduleUpdateDate: 'ダイヤ改定日',
      extraTrain: '臨時便'
    },
    trainService: {
      title: '座指ダイヤ詳細',
      createTitle: '列車新規追加',
      editTitle: '列車修正',
      type: {
        weekday: 'Aダイヤ', // 平日ダイヤ
        holiday: 'Bダイヤ' // 休日ダイヤ
      },
      trainServiceNumber: '列車番号',
      trainServiceNo: '号',
      timetables: '発着時刻',
      arrive: '着',
      depart: '発',
      createComplete: '座指ダイヤ登録完了しました'
    },
    trainAssignment: {
      list: {
        title: '車両運用確定処理'
      },
      title: '車両運用',
      create: '車両運用登録',
      assignmentDate: '運用日付',
      assignmentPeriod: '運用期間',
      assignmentFrom: '運用開始日',
      assignmentTo: '運用終了日',
      fileName: 'ファイル名',
      trainServiceNumber: '運用列車番号',
      fileImport: 'ファイル取込',
      trainAssignmentFileImport: '車両運用ファイル取込',
      scheduleType: 'ダイヤ区分',
      noSchedulePeriod:
        '指定した運用期間のデータが登録または承認されていません。\n運用期間の状態をご確認のうえ、車両運用の設定を行ってください。',
      noTrainAssignmentDetail:
        '運用期間を指定して車両運用データを登録してください。',
      seatAdjustmentPattern: {
        title: '適用調整席確認',
        trainName: '適用車両',
        adjustmentPattern: '適用調整パターン'
      }
    },
    calendar: {
      list: {
        title: '運行カレンダー一覧'
      },
      title: '運行カレンダー',
      from: '期間FROM',
      to: '期間TO',
      type: {
        weekday: 'Aダイヤ', // 平日ダイヤ
        holiday: 'Bダイヤ', // 休日ダイヤ
        disabled: '運行適用期間外'
      },
      yearMonth: '{{year}}年{{month}}月'
    },
    suspension: {
      list: {
        title: '運休一覧'
      },
      register: '運休登録',
      update: '運休詳細',
      period: '表示期間',
      date: '運行日',
      directionType: '上下区分',
      targetDate: '対象日',
      needTrainAssignment: '車両運用を登録した上で運休情報を登録してください。',
      reason: '運休理由',
      train: '運休列車',
      type: '運休区分',
      section: '運休区間',
      bulkRelease: '一括解除',
      bulkReleaseConfirmMessage:
        '{{date}}の運休・部分運休を全て解除します。解除後一覧からは削除されます。',
      [DirectionFlagEnum.Down]: '下り',
      [DirectionFlagEnum.Up]: '上り',
      trainServiceSuspended:
        '列車番号（{{trainServiceNumber}}）は{{operationStatus}}登録されています。運休区間：{{suspensionStationFromName}} 〜 {{suspensionStationToName}}',
      noResult: '車両の登録情報がありません'
    },
    order: {
      list: {
        title: '予約一覧',
        export: '予約情報一覧'
      },
      /* 列車予約受付画面 */
      inventory: {
        title: '空席情報'
      },
      detail: {
        createTitle: '選択内容確認',
        title: '予約詳細',
        tab: {
          detail: '予約内容',
          history: '変更履歴'
        },
        secureMessage: '以下内容で座席を確保します。'
      },
      history: {
        subTitle: '変更履歴詳細'
      },
      id: '予約ID',
      purchaseChannel: '購入区分',
      purchaseChannelType: {
        [PurchaseChannelEnum.Internal]: '本社／指令',
        [PurchaseChannelEnum.Web]: 'WEB',
        [PurchaseChannelEnum.OnSite]: '車内／駅'
      },
      applicantInfo: '申込情報',
      travellerName: '旅客名',
      travellerNameValue: '{{travellerName}}様',
      locationName: '申込所',
      orderTime: '申込日時',
      adult: '大人',
      child: '小児',
      travallerCount: '乗車人数',
      people: '{{count}}名',
      person: '名',
      travallerCountValue:
        '{{count}}名（大人{{adultCount}}名 / 小児{{childrenCount}}名）',
      trainInfo: '列車情報',
      departureDate: '乗車日',
      departureDateTo: '乗車日TO',
      departureStation: '乗車駅',
      arrivalStation: '降車駅',
      staffName: '受付担当者',
      onlineNumber: 'オンライン番号',
      stationRangeValue:
        '{{departureStation}}（{{departureTime}}発）～ {{arrivalStation}}（{{arrivalTime}}着）',
      seat: '席',
      seatReleaseBefore: '座開放前',
      seatReleaseAfter: '座開放後',
      seatChangeBefore: '座変更前',
      seatChangeAfter: '座変更後',
      reservableSeatNum: '残: {{reservableSeatNum}}席',
      reservableBoxNum: '残: {{reservableBoxNum}}BOX',
      proceedToOrder: '予約へ進む',
      orderStatus: {
        [OrderStatusEnum.Reserved]: '予約済',
        [OrderStatusEnum.Cancelled]: 'キャンセル済'
      },
      orderOperation: {
        [OrderOperationEnum.NewBooking]: '新規作成',
        [OrderOperationEnum.SeatChanged]: '座席変更',
        [OrderOperationEnum.SeatRelease]: '座席開放',
        [OrderOperationEnum.TicketPrinted]: '伝票印刷',
        [OrderOperationEnum.Cancelled]: '予約取消'
      },

      comment: {
        title: '備考記入欄'
      },
      updateConfirm: '変更内容確認',
      releasePerson: '変更人数',
      releaseSeat: '開放座席'
    },
    seatAvailabilityInquiry: {
      title: '空席情報'
    },
    specialSeatAdjustment: {
      title: '枠調整'
    },
    user: {
      title: {
        list: 'アカウント管理',
        create: 'アカウント追加',
        update: 'アカウント詳細'
      },
      uid: 'ユーザーID',
      loginId: 'ログイン用ID',
      displayName: '担当者名',
      phone: '電話番号',
      role: 'ユーザータイプ',
      createTime: '作成日時',
      roleType: {
        [UserRoleEnum.Admin]: '管理者',
        [UserRoleEnum.Applicant]: '担当者'
      },
      group: 'ユーザーグループ',
      groupType: {
        [UserGroupEnum.CommandCenter]: '指令',
        [UserGroupEnum.HeadOffice]: '本社',
        [UserGroupEnum.Station]: '駅',
        [UserGroupEnum.Onboard]: '車内',
        [UserGroupEnum.Contractor]: '協力会社'
      },
      sendPasswordResetEmail: 'パスワードリセットメールを送信'
    },
    operationLog: {
      title: '操作履歴',
      businessModule: 'カテゴリ',
      businessModuleType: {
        [BusinessModuleEnum.WebMaster]: 'マスタ管理',
        [BusinessModuleEnum.WebOperation]: '座席管理',
        [BusinessModuleEnum.WebUser]: 'ユーザー管理',
        [BusinessModuleEnum.OnboardSales]: '車内販売'
      },
      businessItem: 'カテゴリ詳細',
      businessItemType: {
        [BusinessItemEnum.RollingStock]: '車両登録',
        [BusinessItemEnum.Station]: '停車駅設定',
        [BusinessItemEnum.Calendar]: 'カレンダー',
        [BusinessItemEnum.SeatDiagram]: '座指ダイヤ',
        [BusinessItemEnum.RollingStockAssignment]: '車両運用確定処理',
        [BusinessItemEnum.Suspension]: '運休',
        [BusinessItemEnum.TrainReservation]: '列車予約受付',
        [BusinessItemEnum.ReservationDetail]: '列車予約詳細',
        [BusinessItemEnum.SeatClass]: '席扱い区分',
        [BusinessItemEnum.Account]: 'アカウント',
        [BusinessItemEnum.ExpressTicketSale]: '特急券販売',
        [BusinessItemEnum.ExpressTicketDetail]: '特急券詳細'
      },
      operationAt: '操作日時',
      businessAction: '操作内容',
      operator: '操作者',
      additionalInfo: '付帯情報'
    },
    stationSeatingTimetable: {
      title: '時刻表',
      filters: {
        date: '日付',
        station: '乗車駅'
      },
      carNo: '{{carNo}}号車',
      time: '時刻',
      trainStatus: '運行ステータス',
      destination: '行先',
      seatsRemaining: '残{{num}}席',
      boxesRemaining: '残{{num}}BOX'
    },
    seatOrderHistory: {
      title: '座席選択',
      filters: {
        departureStation: '乗車駅',
        arrivalStation: '降車駅'
      },
      noTrainAssigned:
        '選択された日程の対象列車は、車両運用が登録されていません',
      noSpecialSeatAdjustmentDetail:
        '選択された日程の対象列車は、席情報が見つかりません',
      noSeatLayout: '座席レイアウトがありません',
      carNoSeatNo: '{{carNo}}号車 {{seatNo}}席',
      carNoBoxName: '{{carNo}}号車 BOX{{boxName}}',
      detail: {
        title: '座席履歴',
        noSeatHistory: 'この座席の予約履歴はありません',
        noBoxHistory: 'このBOXの予約履歴はありません',
        orderDatetime: '予約日時',
        orderId: '予約ID',
        travelSection: '乗車区間',
        applicationType: '申込み区分',
        staffName: '担当者'
      }
    }
  },
  validation: {
    required: '{{name}}を入力してください',
    requiredSelect: '選択してください',
    requiredAll: '全ての{{name}}を入力してください',
    requiredSelectAll: '全ての{{name}}を選択してください',
    itemSelect: '{{name}}を選択してください',
    invalid: '{{name}}が不正です。',
    invalidInput: '有効な{{name}}を入力してください',
    invalidSelect: '有効な{{name}}を選択してください',
    fetchFailed: '{{name}}の取得に失敗しました',
    invalidFirebaseLogin:
      'ログインに失敗しました。メールアドレスまたはパスワードを確認してください。',
    invalidFirebaseTenantIdMismatch:
      'ログインに失敗しました。担当者にお問い合わせください。',
    invalidUserInfo:
      'ユーザー情報が取得できませんでした。メールアドレスまたはパスワードを確認してください。',
    userNotFound: 'ユーザーが見つかりません。再度ログインしてください。',
    userInfoNotFound: 'ユーザー情報が見つかりません。',
    duplicate: 'この{{name}}が既に登録されています。',
    password: {
      invalid:
        '大文字、小文字、記号、数字を組み合わせた12文字以上で作成ください',
      wrongPassword: '現在のパスワードが正しくありません',
      weakPassword:
        '新しいパスワードが脆弱です。より強力なパスワードを設定してください',
      requiresRecentLogin:
        'セキュリティのため、再度ログインしてからパスワードを変更してください',
      userMismatch: '認証情報が一致しません',
      userNotFound: 'ユーザーが見つかりません',
      invalidCredential: '現在のパスワードが正しくありません',
      failed: 'パスワードの更新に失敗しました。もう一度お試しください。'
    },
    number: '半角数字を入力してください',
    maxCharacters: '{{name}}は{{max}}文字以内で入力してください',
    invalidDateRangeTo: '{{to}}は{{from}}より後にしてください',
    invalidOneYearDateRange:
      '{{from}}と{{to}}は、1年以内の範囲で指定してください。',
    cannotIncreasePassengerCount: '{{type}}乗車人数を増やすことはできません',
    cannotBeNegative: '0以上の値を入力してください',
    seatCountExceeded: '選択可能な座席数を超えています',
    noSeatRelease: '乗車人数が変更されていないため、座席開放は行われていません',
    noSeatSelected: '座席が選択されていません',
    requiredDataMissing:
      '必要な情報が取得できませんでした。画面を再読み込みして、もう一度お試しください',
    seatReleaseCannotBeZero:
      '乗車人数を0人にすることはできません。座席取消手続きから取消を行ってください',
    seatCountMismatch: '選択数が人数と一致していません',
    line: {
      missingField: '行{{line}}の{{name}}が未入力です',
      cannotModify:
        '行{{line}}の運用日付{{date}}は既に申請済のため変更できません',
      invalidFile:
        '行{{line}}の{{name}}が不正です。ファイルを修正してから再度取り込んでください',
      invalidArrivalBeforeDeparture:
        '行{{line}}の到着は出発より後の時刻を入力してください',
      invalidArrivalAfterPreviousDeparture:
        '行{{line}}の到着は前の駅の出発より後の時刻にしてください'
    },
    fileEmpty: 'ファイルが空です。ファイルを確認してから再度取り込んでください',
    fileParseFailed:
      'ファイルの解析に失敗したか、一部のデータが正しく読み込めなかった可能性があります。ファイルを確認してから再度取り込んでください',
    fileReadFailed:
      'ファイルの読み込みに失敗しました。ファイルを確認してから再度取り込んでください',
    passwordReset: {
      emailNotFound: '入力されたメールアドレスが見つかりません。',
      failed: 'メール送信に失敗しました。',
      invalidLink: '不正なリンクです。再度パスワード再設定を行ってください。',
      expiredLink:
        'リンクの有効期限が切れています。再度パスワード再設定を行ってください。'
    },
    firebase: {
      emailAlreadyInUse: 'このメールアドレスは既に登録されています。',
      wrongPassword:
        'このメールアドレスは既に登録されていますが、パスワードが間違っています。',
      invalidEmail: 'メールアドレスの形式が正しくありません。',
      operationNotAllowed: 'メール/パスワード認証が有効になっていません。',
      tooManyRequests:
        'リクエストが多すぎます。しばらく待ってから再試行してください。',
      invalidCredential: 'メールアドレスまたはパスワードが間違っています。',
      networkRequestFailed: 'ネットワークエラーが発生しました。',
      unexpectedError: 'Firebaseで予期しないエラーが発生しました。'
    }
  }
};
